module.exports = __webpack_public_path__ + "img/nus-thumbnail.b61f915b.png";